@switch (step) {
  @case (0) {
    <h1 mat-dialog-title>Choose a Timesheet Already On The Page</h1>
    <mat-dialog-content>
      <bar-select itemName="Timesheet" class="flex-0" [items]="timesheets" (itemChosen)="select($event)" />
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button (click)="goToContractSelect()">Find Other Timesheet</button>
    </mat-dialog-actions>
  }
  @case (1) {
    <h1 mat-dialog-title>Choose a Contract</h1>
    <mat-dialog-content>
      <contract-select
        headerText=""
        [hasEmbeddedComponent]="true"
        [shouldDisableWeDate]="true"
        (next)="goToTimesheetSelect($event)"
        (backClicked)="close()"
      />
    </mat-dialog-content>
  }
  @case (2) {
    <h1 mat-dialog-title>Choose a Timesheet</h1>
    <mat-dialog-content>
      <div class="flex w-full items-center justify-around">
        <div>
          <strong>Contract Name: </strong> {{ contract.contractName }}
          <br />
          <strong>Contract Dates:</strong> {{ contract.contractDateRange }}
        </div>
        <wedate-input [dateHandler]="handler" [hasIncrementors]="false" [shouldDisable]="true" />
      </div>
      <bar-select
        itemName="Timesheets"
        nullMessage="There are no timesheets for this contract and weekending date. Use timesheet manager to make a new timesheet."
        [items]="timesheets"
        [isSearching]="isSearching"
        (itemChosen)="select($event)"
      />
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button (click)="makeNewTimesheet()">Go To Timesheet Manager</button>
    </mat-dialog-actions>
  }
}
